import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  style: {
    "min-height": "120px"
  },
  "element-loading-background": "rgba(255, 255, 255, 0.6)"
};
export default /*#__PURE__*/_defineComponent({
  props: {
    loading: Boolean
  },
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _directive_loading = _resolveDirective("loading");

      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [_renderSlot(_ctx.$slots, "default")])), [[_directive_loading, __props.loading]]);
    };
  }
});